import type { ToolCatalogEntry } from '../types';
import { TOOL_CATALOG } from '../catalog';

/**
 * Read-only access to the generated tool catalog. The editable overlay, a tool's description override
 * and off switch, is ToolConfig (useToolConfigs), not this store.
 */
export const toolCatalogStore = {
  getAll(): ToolCatalogEntry[] {
    return TOOL_CATALOG;
  },
  getByActionId(actionId: string): ToolCatalogEntry | undefined {
    return TOOL_CATALOG.find((e) => e.actionId === actionId);
  },
};
